export const SETTINGS_FILTER_PHOTO_VERIFICATION_ANNOUNCEMENT =
  'SETTINGS_FILTER_PHOTO_VERIFICATION_ANNOUNCEMENT' as const

export const settingsFilterPhotoVerificationAnnouncementAction = (
  profileId: number
) => ({
  profileId,
  type: SETTINGS_FILTER_PHOTO_VERIFICATION_ANNOUNCEMENT,
})
